import { Tooltip as MuiTooltip } from "@mui/material";
import PropTypes from "prop-types";


export default function CustomTooltip(props) {
  const tooltipContent = props["data-tooltip-content"];
  const isMobile = window.innerWidth <= 768;

  // Don't render tooltip on mobile
  if (isMobile) {
    return <>{props.children}</>;
  }

  // Don't render tooltip if show is false
  if (!props.show) {
    return <>{props.children}</>;
  }

  return (
    <MuiTooltip
      title={tooltipContent}
      enterDelay={props?.delay ?? 1000}
      enterNextDelay={0}
      leaveDelay={0}
      placement="top"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: props.bgColor || "#000000",
            color: props.textColor || "#ffffff",
            fontWeight: 600,
            borderRadius: "10px",
            maxWidth: "220px",
            wordWrap: "break-word",
            paddingTop: "6px",
            paddingBottom: "6px",
            paddingRight: "8px",
            paddingLeft: "10px",
            fontSize: "13px",
            lineHeight: "20px",
            textAlign: "left",
            zIndex: 10000,
            "& .MuiTooltip-arrow": {
              color: props.bgColor || "#000000",
            },
          },
        },
      }}
    >
      <div>{props.children}</div>
    </MuiTooltip>
  );
}

CustomTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool,
  delay: PropTypes.number,
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  "data-tooltip-content": PropTypes.string.isRequired,
};